import React from 'react';

import { LabelValue, LabelValueTypeConfig, withLabelTokenParsing } from './Content.jsx';
import Token from '../utility/Token.jsx';
import Utilities from '../utility/Utilities.jsx';

// #region STAFF

function _Staff(props) {
    const data = props.data || {};
    const hasValue = !Utilities.isNullOrWhitespace(data.StaffName);
    if (!props.builder) {
        if (!hasValue) {
            return null;
        }
        const config = props.config || {};
        if (!props.forceVisibility && !Utilities.Config.getVisibility(config, 'Staff')) {
            return null;
        }
    }
    return <LabelValue {...props} renderPlaceholder={!hasValue} value={props.content} />;
}
const Staff = withLabelTokenParsing(_Staff, (props, keyword) => {
    const data = props.data || {};
    let replaceString = '';
    switch (keyword) {
        case Token.StaffName:
            if (!Utilities.isNullOrWhitespace(data.StaffName)) {
                replaceString = data.StaffName;
            }
            break;
        default:
            replaceString = undefined;
            break;
    }
    return replaceString;
});
const Tokens = () => [{ display: 'User Name', token: Token.StaffName }];
const TypeConfig = {
    panel: {
        block: LabelValueTypeConfig.panel.block,
        description: LabelValueTypeConfig.panel.description,
        label: (display) => LabelValueTypeConfig.panel.label(Utilities.wrapTextForEditor({ text: display || 'Staff:'})),
        style: LabelValueTypeConfig.panel.style,
        value: () => LabelValueTypeConfig.panel.value(Utilities.wrapTextForEditor({ text: `{${Token.StaffName}}`, token: Token.StaffName })),
        visibility: () => {
            return {
                options: [
                    {
                        configurableDuringExport: () => true,
                        display: 'User Name',
                        name: 'Staff',
                        type: 'checkbox',
                        value: true,
                        visible: () => false
                    }
                ]
            };
        }
    }
};

// #endregion STAFF


export {
    Staff as Component,
    Tokens,
    TypeConfig
}